var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('div',{staticClass:"col history",domProps:{"innerHTML":_vm._s(_vm.options.about_desc)}}),_c('div',{staticClass:"col content",domProps:{"innerHTML":_vm._s(_vm.options.about_content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }